import React from 'react';
import { Alert, Box } from '@mui/material';
import { urlManager } from '../../../../../../Utils/URL/URLManager';
import { LinkStyled } from '../../../../../../Components/Links/BaseLink/BaseLink.styles';

interface Props {}

const SuccessView: React.FC<Props> = () => (
  <Alert
    variant="standard"
    severity="success"
    sx={{
      fontSize: '8pt',
    }}
  >
    <Box>Your password has been successfully changed.</Box>
    <Box>
      You can now follow{' '}
      <LinkStyled to={urlManager.signIn()}>to login</LinkStyled>.
    </Box>
  </Alert>
);

export default SuccessView;
